/* Change this file to get your personal Porfolio */

import logo from "./assets/images/logo_optimized.png";

// Website related settings
const settings = {
  isSplash: true, // Change this to true if you want to use the splash screen.
  useCustomCursor: true, // Change this to false if you want the good'ol cursor
};

//Home Page
const greeting = {
  title: "Hi",
  title2: "Taro Shibusawa",
  logo_name: "X-iT",
  full_name: "Taro Shibusawa",
  subTitle1: "Principal Software Engineer",
  subTitle2: "AI/ML & GenAI Engineer",
  subTitle: "Full Stack Architect",
  summary:
    "AI/ML software engineer and Fullstack architect with over 8 years building and leading production-grade AI systems and scalable applications. I close the gap between cutting-edge AI research and tangible business value - owning problems end-to-end, from data pipelines and machine learning models through to the final user interface, and delivering solutions that drive measurable ROI.",
  resumeLink:
    "https://docs.google.com/document/d/1_pQHV9aoVwP4DfTejBMiIKWF-GVkLL39hxoIisW1MD4/edit?usp=sharing",
};

const socialMediaLinks = {
  /* Your Social Media Link */
  github: "https://github.com/X-iT-0",
  linkedin: "https://www.linkedin.com/in/taro-shibusawa-92aa6b408/",
  gmail: "taro.n4g@gmail.com",
  twitter: "",
};

const skills = {
  data: [
    {
      _id: "354c54b7-ffd8-40f1-972f-1d006733df25",
      title: "AI/ML & GenAI",
      fileName: "AIMLGenAIImg",
      skills: [
        "⚡ Building RAG pipelines, LLM evaluation frameworks, and multi-agent orchestration systems",
        "⚡ Designing real-time voice AI pipelines with ~1s latency using Vapi, Retell AI, and ElevenLabs",
        "⚡ Integrating OpenAI, Anthropic Claude, LangChain, PyTorch, and TensorFlow into production systems",
      ],
      softwareSkills: [
        {
          skillName: "Python",
          fontAwesomeClassname: "logos:python",
          style: { color: "#3776AB" },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos:pytorch-icon",
          style: { color: "#EE4C2C" },
        },
        {
          skillName: "TensorFlow",
          fontAwesomeClassname: "logos:tensorflow",
          style: { color: "#FF6F00" },
        },
        {
          skillName: "Scikit-learn",
          fontAwesomeClassname: "simple-icons:scikitlearn",
          style: { color: "#F37626" },
        },
        {
          skillName: "Keras",
          svgIcon: "keras",
          style: { color: "#D00000" },
        },
        {
          skillName: "XGBoost",
          svgIcon: "xgboost",
          style: { color: "#1D3533" },
        },
        {
          skillName: "LangChain",
          fontAwesomeClassname: "simple-icons:langchain",
          style: { color: "#1C3C3C" },
        },
        {
          skillName: "LangGraph",
          fontAwesomeClassname: "simple-icons:langgraph",
          style: { color: "#1C3C3C" },
        },
        {
          skillName: "LangSmith",
          svgIcon: "langsmith",
          style: { color: "#1C3C3C" },
        },
        {
          skillName: "OpenAI",
          fontAwesomeClassname: "logos:openai-icon",
          style: { color: "#412991" },
        },
        {
          skillName: "Anthropic Claude",
          fontAwesomeClassname: "simple-icons:anthropic",
          style: { color: "#D4A27F" },
        },
        {
          skillName: "Hugging Face",
          fontAwesomeClassname: "logos:hugging-face-icon",
          style: { color: "#FFD21E" },
        },
        {
          skillName: "ElevenLabs",
          fontAwesomeClassname: "simple-icons:elevenlabs",
          style: { color: "#000000" },
        },
        {
          skillName: "FAISS",
          svgIcon: "faiss",
          style: { color: "#0668E1" },
        },
        {
          skillName: "Pinecone",
          svgIcon: "pinecone",
          style: { color: "#1CEC83" },
        },
      ],
    },
    {
      _id: "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building scalable full-stack apps with React, Next.js, Node.js, and mobile clients in Flutter & React Native",
        "⚡ Designing REST, GraphQL, and WebSocket APIs for real-time web and mobile data synchronization",
        "⚡ Implementing OAuth2/JWT authentication, CI/CD pipelines, and microservices architecture",
      ],
      softwareSkills: [
        {
          skillName: "TypeScript",
          fontAwesomeClassname: "logos:typescript-icon",
          style: { color: "#3178C6" },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "logos:javascript",
          style: { backgroundColor: "#FFFFFF", color: "#F7DF1E" },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "logos:java",
          style: { color: "#ED8B00" },
        },
        {
          skillName: "SQL",
          fontAwesomeClassname: "vscode-icons:file-type-sql",
          style: { color: "#CC2927" },
        },
        {
          skillName: "React",
          fontAwesomeClassname: "simple-icons:react",
          style: { color: "#61DAFB" },
        },
        {
          skillName: "Next.js",
          fontAwesomeClassname: "logos:nextjs-icon",
          style: { color: "#000000" },
        },
        {
          skillName: "React Native",
          fontAwesomeClassname: "simple-icons:react",
          style: { color: "#61DAFB" },
        },
        {
          skillName: "Flutter",
          fontAwesomeClassname: "logos:flutter",
          style: { color: "#02569B" },
        },
        {
          skillName: "Swift",
          svgIcon: "swift",
          style: { color: "#F05138" },
        },
        {
          skillName: "Node.js",
          fontAwesomeClassname: "logos:nodejs-icon",
          style: { color: "#339933" },
        },
        {
          skillName: "FastAPI",
          fontAwesomeClassname: "devicon:fastapi",
          style: { color: "#009688" },
        },
        {
          skillName: "Django",
          fontAwesomeClassname: "simple-icons:django",
          style: { color: "#092E20" },
        },
        {
          skillName: "Spring Boot",
          fontAwesomeClassname: "logos:spring-icon",
          style: { color: "#6DB33F" },
        },
        {
          skillName: "GraphQL",
          fontAwesomeClassname: "logos:graphql",
          style: { color: "#E10098" },
        },
      ],
    },
    {
      _id: "c026fe64-1542-42b0-84ab-9311840c169f",
      title: "Cloud & Data Infrastructure",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Architecting event-driven microservices on AWS (Lambda, ECS, API Gateway, SageMaker, Kinesis, S3)",
        "⚡ Managing containerized deployments with Docker, Kubernetes, and Terraform IaC",
        "⚡ Operating streaming pipelines (Kafka, Kinesis) and vector stores (Pinecone, FAISS) at scale",
      ],
      softwareSkills: [
        {
          skillName: "AWS",
          fontAwesomeClassname: "skill-icons:aws-dark",
          style: {
            backgroundColor: "transparent",
            width: "1em",
            height: "1em",
          },
        },
        {
          skillName: "GCP",
          fontAwesomeClassname: "skill-icons:gcp-dark",
          style: { color: "#4285F4" },
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "logos:microsoft-azure",
          style: { color: "#0078D4" },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "logos:docker-icon",
          style: { color: "#1488C6" },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "logos:kubernetes",
          style: { color: "#326CE5" },
        },
        {
          skillName: "Terraform",
          fontAwesomeClassname: "logos:terraform-icon",
          style: { color: "#7B42BC" },
        },
        {
          skillName: "GitHub Actions",
          fontAwesomeClassname: "simple-icons:githubactions",
          style: { color: "#2088FF" },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "logos:postgresql",
          style: { color: "#336791", width: "1em", height: "1em" },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "logos:mysql",
          style: { color: "#4479A1", width: "1em", height: "1em" },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "logos:mongodb",
          style: { color: "#47A248", width: "1em", height: "1em" },
        },
        {
          skillName: "DynamoDB",
          fontAwesomeClassname: "logos:aws-dynamodb",
          style: { color: "#4053D6" },
        },
        {
          skillName: "Redis",
          fontAwesomeClassname: "logos:redis",
          style: { color: "#DC382D", width: "1em", height: "1em" },
        },
        {
          skillName: "Apache Airflow",
          svgIcon: "airflow",
          style: { color: "#017CEE" },
        },
        {
          skillName: "Kafka",
          fontAwesomeClassname: "logos:kafka-icon",
          style: { color: "#231F20", width: "1em", height: "1em" },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: { color: "#E94E32" },
        },
      ],
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "University of Osaka, Osaka, Japan",
      subtitle: "Bachelor of Science in Mathematics & Statistics",
      logo_path: "osaka_logo.png",
      alt_name: "University of Osaka",
      duration: "04/2008 - 09/2012",
      descriptions: [
        "⚡ Built a strong foundation in probability, statistics, and discrete mathematics that underlies my approach to ML systems and data-driven engineering decisions.",
      ],
      website_link: "https://www.osaka-u.ac.jp/en",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "ML and AI in GCP",
      subtitle: "- GCP Training",
      logo_path: "gcp_logo.png",
      certificate_link:
        "",
      alt_name: "GCP",
      color_code: "#2fa9508a",
    },
    {
      title: "Java Programming: Build a Recommendation System",
      subtitle: "",
      logo_path: "duke-logo.jpg",
      certificate_link:
        "",
      alt_name: "Duke University",
      color_code: "#001a57",
    },
    {
      title: "Programming with JavaScript",
      subtitle: "",
      logo_path: "duke-logo.jpg",
      certificate_link:
        "",
      alt_name: "Meta",
      color_code: "#001a57",
    },
    {
      title: "Java Programming: Principles of Software Design",
      subtitle: "",
      logo_path: "duke-logo.jpg",
      certificate_link:
        "",
      alt_name: "Duke University",
      color_code: "#001a57",
    },
    {
      title: "Java Programming: Solving Problems with Software",
      subtitle: "",
      logo_path: "duke-logo.jpg",
      certificate_link:
        "",
      alt_name: "Duke University",
      color_code: "#001a57",
    },
    {
      title: "Fullstack Development",
      subtitle: "",
      logo_path: "coursera_logo.png",
      certificate_link:
        "",
      alt_name: "Coursera",
      color_code: "#0056d2",
    },
    {
      title: "Foundational Infrastructure in GCP",
      subtitle: "- GCP Training",
      logo_path: "gcp_logo.png",
      certificate_link:
        "",
      alt_name: "GCP",
      color_code: "#4087f08a",
    },
    {
      title: "Frontend Developer Capstone",
      subtitle: "",
      logo_path: "meta_logo.png",
      certificate_link:
        "",
      alt_name: "Meta",
      color_code: "#096ce1",
    },
    {
      title: "Advanced React",
      subtitle: "",
      logo_path: "meta_logo.png",
      certificate_link:
        "",
      alt_name: "Meta",
      color_code: "#096ce1",
    },
    {
      title: "React Basics",
      subtitle: "",
      logo_path: "meta_logo.png",
      certificate_link:
        "",
      alt_name: "Meta",
      color_code: "#096ce1",
    },
    {
      title: "HTML and CSS in depth",
      subtitle: "",
      logo_path: "meta_logo.png",
      certificate_link:
        "",
      alt_name: "Meta",
      color_code: "#096ce1",
    },
    {
      title: "Programming Foundations with JavaScript, HTML and CSS",
      subtitle: "",
      logo_path: "duke-logo.jpg",
      certificate_link:
        "",
      alt_name: "Duke University",
      color_code: "#001a57",
    },
    {
      title: "Android Application Development - II",
      subtitle: "- Dr. Adam Porter",
      logo_path: "maryland_logo.svg",
      certificate_link:
        "",
      alt_name: "Stanford University",
      color_code: "#e11a2b",
    },
    {
      title: "Android Application Development - I",
      subtitle: "- Dr. Adam Porter",
      logo_path: "maryland_logo.svg",
      certificate_link:
        "",
      alt_name: "Stanford University",
      color_code: "#e11a2b",
    },
    {
      title: "Networking & Security in GCP",
      subtitle: "- GCP Training",
      logo_path: "gcp_logo.png",
      certificate_link:
        "",
      alt_name: "GCP",
      color_code: "#eb40308a",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  // subtitle: "Work and Learn",
  description:
    "8+ years shipping production systems — from real-time GenAI clinical platforms and RAG pipelines to financial SaaS and ML-enabled data infrastructure. I own problems end-to-end: architecture, delivery, and the metrics that prove it worked.",
  //   "Over 8 years shipping production systems — from real-time GenAI clinical platforms and RAG pipelines to financial SaaS and ML-enabled data infrastructure. I own problems end-to-end: architecture, delivery, and the metrics that prove it worked.",
  // header_image_path: "experience.svg",
  sections: {
    title: "Work Experience",
    experiences: [
      {
        title: "Principal Software Engineer",
        company: "Doist",
        company_url: "",
        logo_path: "doist_logo.png",
        alt_name: "Doist",
        duration: "08/2022 - 10/2025",
        location: "Palo Alto, US (Remote)",
        description:
          "<li>Architected a multi-tenant GenAI clinical platform supporting 200+ concurrent voice and text AI sessions using event-driven microservices on AWS.</li><li>Built a real-time voice AI pipeline converting continuous clinical conversations into structured medical entities with ~1s latency and 97% extraction accuracy, enabling automated documentation workflows.</li><li>Designed and deployed production RAG systems using LangChain and vector databases (Pinecone/FAISS), improving patient-history summarization accuracy with retrieval evaluation achieving 0.9 precision.</li><li>Developed a modular LLM orchestration layer separating retrieval, prompt execution, and inference services, enabling controlled experimentation and rapid feature delivery.</li><li>Reduced frontend payload size by 40%, maintaining sub-second responsiveness across streaming AI interfaces. Led infrastructure automation with Terraform and GitHub Actions, achieving 98% automated test coverage.</li><li>Mentored 6 engineers across distributed systems design, async Python, and GenAI platform development.</li>",
        color: "#DB4035",
      },
      {
        title: "Software Engineer",
        company: "ELEKS",
        company_url: "",
        logo_path: "eleks_logo.png",
        alt_name: "ELEKS",
        duration: "02/2020 - 06/2022",
        location: "Tokyo, Japan (Remote)",
        description:
          "<li>Developed production full-stack applications using React and Node.js supporting secure customer financial workflows at scale.</li><li>Designed microservices architectures improving system scalability and resilience across distributed services.</li><li>Built REST and WebSocket APIs enabling real-time synchronization of financial data during peak usage.</li><li>Implemented OAuth2 and JWT authentication systems strengthening platform security and compliance.</li><li>Reduced release cycles from weeks to under 24 hours through CI/CD automation using Docker and Jenkins.</li><li>Improved frontend performance by ~30% via lazy loading, caching strategies, and bundle optimization.</li>",
        color: "#0071C5",
      },
      {
        title: "Data Specialist",
        company: "Base System",
        company_url: "",
        logo_path: "base_systemes_logo.png",
        alt_name: "Base System",
        duration: "02/2015 - 05/2020",
        location: "Tokyo, Japan",
        description:
          "<li>Operated streaming ingestion platforms processing 3,000 events/sec using Kafka, AWS Kinesis, and Azure Event Hubs.</li><li>Maintained centralized PostgreSQL data warehouse with Redis caching achieving ~200ms p95 analytical query latency.</li><li>Developed React + D3.js analytics dashboards enabling 50+ stakeholders to visualize clinical and operational insights.</li><li>Applied Bayesian optimization models improving clinical trial site selection efficiency by ~18%.</li><li>Built predictive models for radiological analysis and equipment failure forecasting, reducing downtime by ~28%.</li>",
        color: "#4285F4",
      },
      {
        title: "Data Analyst",
        company: "Sakura Data System",
        company_url: "",
        logo_path: "sakura_logo.png",
        alt_name: "Sakura Data System",
        duration: "02/2013 - 11/2014",
        location: "Tokyo, Japan",
        description:
          "<li>Built Fraud Fighter (Python + Node.js + AWS Lambda) that reduced platform abuse by 20% and boosted user engagement by 30% — owned concept, build, and production deployment solo.</li><li>Redesigned denormalized SQL schema on AWS RDS achieving a 6x query performance gain.</li><li>Migrated Backbone.js frontend to React, reducing bundle size and improving long-term maintainability.</li>",
        color: "#0F9D58",
      },
    ],
  },
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "Production systems across AI/CV, SaaS rescue & rebuild, enterprise data sync, and geospatial ML. Every project was shipped end-to-end — architecture, build, and deployment.",
  avatar_image_path: "projects_image.svg",
};

const projects = {
  data: [
    {
      id: "project-0",
      name: "AI-Powered Padel Referee System",
      screenshotsFolder: "AI Padel Refree Platform",
      url: "",
      repoUrl: "",
      description:
        "World's first AI-powered automated refereeing system for padel. Multi-camera computer vision pipeline — ball tracking, 4-player skeleton detection, and court boundary recognition running at 60fps with sub-16ms decision latency. Validated against a 20-match test dataset at 99.9% accuracy. Solo build: full-stack + CV engineering.",
      details: {
        role: "Solo build — full-stack + CV engineering",
        about:
          "Built a web platform for the world's first AI-powered automated refereeing system for padel. Combines multi-camera computer vision with a live adjudication engine — ball tracking, 4-player skeleton detection, and court boundary recognition running at 60fps with sub-16ms decision latency.",
        problem:
          "Human referees miss high-speed ball events and can't simultaneously track four players across multiple camera angles. No existing product combined refereeing and match analysis in a single real-time system.",
        solution:
          "Built a multi-stage CV pipeline: high-speed ball detection → player tracking with confidence scoring (0.79–0.88) → court boundary recognition → rule engine → WebSocket-streamed decisions to a React dashboard. Solved fast-moving object detection and multi-player occlusion using staged pipeline with object re-identification between frames.",
        done: [
          "All 4 players and ball tracked simultaneously across 8 cameras at 60fps",
          "Automated out-calls and rule decisions delivered to dashboard in <16ms",
          "Court boundaries resolved without human input",
          "Validated against 20-match test dataset at 99.9% accuracy",
        ],
        stack: ["Python", "OpenCV", "YOLOv8", "PyTorch", "FastAPI", "React", "WebSockets", "Object Tracking", "Pose Estimation"],
      },
      languages: [
        {
          name: "Python",
          iconifyClass: "logos:python",
        },
        {
          name: "OpenCV",
          iconifyClass: "simple-icons:opencv",
        },
        {
          name: "PyTorch",
          iconifyClass: "logos:pytorch-icon",
        },
        {
          name: "FastAPI",
          iconifyClass: "devicon:fastapi",
        },
        {
          name: "React",
          iconifyClass: "logos:react",
        },
        {
          name: "WebSockets",
          iconifyClass: "simple-icons:socketdotio",
        },
      ],
    },
    {
      id: "project-1",
      name: "AMZAlert — Amazon Seller Intelligence SaaS",
      screenshotsFolder: "Caltalogs thousnads of Amazon products every minute (Built from scratch)",
      url: "",
      repoUrl: "",
      description:
        "Inherited a broken Amazon monitoring SaaS — stabilised the failing 15-minute scrape cycle in under a week, then rebuilt the entire system from scratch. Per-user job isolation, optimised SQL query patterns, async scraping engine, and alert routing covering price, title, review count, BuyBox status, hijacker detection, and MAP violations. Still live in production.",
      details: {
        role: "Sole developer — full diagnosis, stabilisation, and rebuild",
        about:
          "AMZAlert is a live subscription SaaS that scrapes Amazon product data every 15 minutes and fires SMS/email alerts when prices, titles, reviews, hijackers, or MAP violations change. Inherited a broken codebase, stabilised it in under a week, then rebuilt the entire system from scratch. Still in production today.",
        problem:
          "The previous developer's architecture used a shared global queue — every new subscriber slowed performance for all existing users. By 50 users the 15-minute scrape was taking 2+ hours, customers were churning, and refunds were being issued. There was no path to scale without a full rebuild.",
        solution:
          "Diagnosed the shared-queue bottleneck on day one. Patched the critical scrape path and restored the 15-minute cycle in under a week. Then designed and built a replacement system from scratch: per-user job isolation, optimised SQL query patterns, async scraping engine, and a clean alert-routing layer covering price, title, review count, BuyBox status, hijacker detection, and MAP violations.",
        done: [
          "15-minute Amazon scrape cycle running reliably for all concurrent users",
          "SMS and email alerts firing accurately across all tracked event types",
          "No shared-queue degradation as subscriber count grows",
          "System confirmed stable and in active production",
        ],
        stack: ["C#", ".NET Framework", "Microsoft SQL Server", "Database Architecture", "Async Scraping", "SaaS Architecture", "SMS Alerting"],
      },
      languages: [
        {
          name: "C#",
          iconifyClass: "devicon:csharp",
        },
        {
          name: ".NET",
          iconifyClass: "logos:dotnet",
        },
        {
          name: "SQL Server",
          iconifyClass: "simple-icons:microsoftsqlserver",
        },
      ],
    },
    {
      id: "project-2",
      name: "CDOL — Construction Cost Data SaaS",
      screenshotsFolder: "CDOL - Subscription Based DB Web Application",
      url: "",
      repoUrl: "",
      description:
        "Full ownership of a subscription SaaS delivering 45+ years of Richardson Estimating Standards pricing data to construction estimators. Migrated a legacy database across US, Canada, and International markets, provisioned all servers, and built a complete SPA with subscriber auth, 15+ category hierarchical navigation, dynamic filterable pricing tables, and an estimating list workflow.",
      details: {
        role: "Sole developer — full ownership across database migration, API, SPA, and server infrastructure",
        about:
          "CDOL (Cost Data On Line) is a subscription SaaS giving construction estimators access to a massive proprietary pricing database — material rates, labour costs, process plant specs, and international cost factors built on 45+ years of Richardson Estimating Standards.",
        problem:
          "The client held decades of proprietary construction pricing data locked in a legacy format with no web distribution channel. They needed the entire dataset converted, restructured, and delivered behind a subscription gate — with per-market filtering, hierarchical account navigation, and a working estimating workflow.",
        solution:
          "Migrated the full legacy pricing database to a new schema across US, Canada, and International market regions. Provisioned and managed web, API, and database servers. Built a full SPA with subscriber auth, market selector, 15+ category hierarchical navigation with multi-level drill-down, dynamic filterable pricing tables, and an estimating list workflow with material detail modals.",
        done: [
          "Full legacy dataset migrated with no data loss",
          "All 6 product modules live — Market Reports, Labor Data, Cost Factor Manual, Process Plant Data, and more",
          "Subscriber auth, per-market filtering, and estimating list workflow all functional",
          "Web, API, and DB servers provisioned and deployed",
          "Admin user management active",
        ],
        stack: ["React", "TypeScript", "Node.js", "PostgreSQL", "REST API", "Legacy DB Migration", "Server Provisioning", "Subscription Auth"],
      },
      languages: [
        {
          name: "React",
          iconifyClass: "logos:react",
        },
        {
          name: "TypeScript",
          iconifyClass: "logos:typescript-icon",
        },
        {
          name: "Node.js",
          iconifyClass: "logos:nodejs",
        },
        {
          name: "PostgreSQL",
          iconifyClass: "logos:postgresql",
        },
        {
          name: "REST API",
          iconifyClass: "simple-icons:fastapi",
        },
      ],
    },
    {
      id: "project-3",
      name: "Enterprise Event Analytics SaaS",
      screenshotsFolder: "HostEvents Analytics Platform",
      url: "",
      repoUrl: "",
      description:
        "Two-module SaaS for enterprise event teams. Module one: sync engine automating data transfers between Salesforce, RainFocus, and Zoom — eliminating manual CSV uploads. Module two: self-serve analytics dashboard with 8 configurable widget types (donut, bar, gauge, treemap, leaderboard, line item) and real-time event performance tracking across regions and campaigns.",
      details: {
        role: "Full-stack developer — sole ownership across sync engine and analytics modules",
        about:
          "A two-module SaaS platform built for enterprises running events across Salesforce, RainFocus, and Zoom. Module one automates all data syncing between CRMs and event tools — eliminating manual CSV uploads. Module two is a self-serve analytics dashboard with 8 configurable widget types and real-time visualisations.",
        problem:
          "Enterprise event teams were manually uploading attendee data between platforms — causing data errors, delayed reporting, inaccurate Salesforce campaign metrics, and zero real-time visibility into live event performance across workflow types.",
        solution:
          "Built a sync engine automating transfers, updates, and deletions across Salesforce, RainFocus, and Zoom — with per-event Campaign ID linkage. Built the full analytics module with 8 self-configurable widget types (donut, bar, line, gauge, table, treemap, leaderboard, line item), each with dataset selection, operator, field mapping, and campaign scope.",
        done: [
          "Salesforce sync automated with no manual data entry",
          "Attendee updates and deletions propagating in real time",
          "Analytics dashboard live with 8 configurable widget types",
          "Event performance trackable by workflow, region, and campaign",
          "Zero data entry errors post-launch confirmed by client",
        ],
        stack: ["Laravel", "React", "Next.js", "Python", "Salesforce API", "RainFocus", "Data Sync Engine", "Real-time Analytics", "SaaS Architecture"],
      },
      languages: [
        {
          name: "Laravel",
          iconifyClass: "logos:laravel",
        },
        {
          name: "React",
          iconifyClass: "logos:react",
        },
        {
          name: "Next.js",
          iconifyClass: "logos:nextjs-icon",
        },
        {
          name: "Python",
          iconifyClass: "logos:python",
        },
        {
          name: "Salesforce",
          iconifyClass: "logos:salesforce",
        },
      ],
    },
    {
      id: "project-4",
      name: "LaunchControl — Real Estate SMS CRM",
      screenshotsFolder: "Launch Control",
      url: "",
      repoUrl: "",
      description:
        "Rescued and rebuilt the #1 rated SMS CRM for real estate professionals. Stabilised a collapsing system immediately, then led a 6-contractor team through a complete ground-up rebuild. Delivers 100k+ SMS/month with 98.1% deliverability. Features a 3-panel prospect CRM with lead temperature scoring, DNC controls, skip tracing, scheduled sends, and a live analytics dashboard. Multi-year engagement.",
      details: {
        role: "Lead developer — managed 6 sub-contractors, full ownership across stabilisation, rebuild, and multi-year growth",
        about:
          "LaunchControl is the #1 rated text messaging platform for real estate professionals — a full CRM + SMS engine handling 100k+ prospect messages per month. Brought in after the original dev team was fired, stabilised the failing system, then led a complete ground-up rebuild with a team of 6 sub-contractors. Multi-year engagement, still live and growing.",
        problem:
          "The original developers had built a system that couldn't scale. Once real users came in, performance collapsed — customers were frustrated, asking for refunds, and the client was losing revenue. The architecture had no path to growth without being thrown away entirely.",
        solution:
          "Stabilised the existing system immediately to stop the bleeding. Made the case for a full rebuild on a custom framework — the right long-term decision. Led 6 sub-contractors across the rebuild and years of ongoing feature development. Delivered a 3-panel prospect CRM with SMS thread view, lead temperature scoring, DNC controls, skip tracing integration, scheduled sends, and a live analytics dashboard.",
        done: [
          "Platform rebuilt from scratch — handles 100k+ SMS/month without degradation",
          "3-panel CRM workflow live with DNC, skip tracing, lead scoring, and scheduled sends",
          "98.1% SMS deliverability rate maintained at scale",
          "Analytics dashboard tracking deliverability and lead pipeline live",
          "Client self-describes as #1 rated and highest converting in their market",
        ],
        stack: ["C#", ".NET Framework", "AngularJS", "Microsoft SQL Server", "IIS", "SMS Engine", "CRM Architecture", "Skip Tracing", "API Integration"],
      },
      languages: [
        {
          name: "C#",
          iconifyClass: "devicon:csharp",
        },
        {
          name: ".NET",
          iconifyClass: "logos:dotnet",
        },
        {
          name: "AngularJS",
          iconifyClass: "logos:angular",
        },
        {
          name: "SQL Server",
          iconifyClass: "simple-icons:microsoftsqlserver",
        },
      ],
    },
    {
      id: "project-5",
      name: "ooVoo — AI Music Generation Platform",
      screenshotsFolder: "Music Generator",
      url: "",
      repoUrl: "",
      description:
        "Full-stack AI music SaaS where users generate original audio samples by configuring genre, BPM, key, duration, and style tags. Built the full AI generation pipeline in Python/PyTorch, a community Explore feed with trending hashtags, creator profiles, sample packs, and a dual monetisation system — credit purchases and 4-tier subscriptions ($0–$49.99/month) with 24-bit WAV export.",
      details: {
        role: "AI + full-stack developer — end-to-end ownership across model, platform, and monetisation",
        about:
          "ooVoo is a full-stack AI music SaaS where users generate original audio samples by configuring genre, BPM range, key, duration, and up to 3 style tags (Dark, Gritty, Atmospheric, Melodic, Glitchy, and more) — or hit Randomize. Generated samples are published to a community Explore feed, managed in personal libraries and packs, monetised via credits and 4-tier monthly subscriptions.",
        problem:
          "Music creation tools are either too complex for non-musicians or produce generic, non-customisable output. The brief required an accessible AI generator with enough creative control to satisfy serious producers, plus a community layer to drive organic content growth and retention.",
        solution:
          "Built the full AI generation pipeline in Python/PyTorch with model tuning for genre-specific output. Wired it to a Next.js/React frontend with a structured generation form. Built the full community layer (Explore feed, creator profiles, followers, sample packs, trending hashtags), a dual monetisation system (credits + 4-tier subscriptions), and WAV export at 16-bit/24-bit depending on tier.",
        done: [
          "AI generator live with 15+ style parameters producing playable in-browser audio",
          "Community Explore feed with trending hashtags and searchable samples",
          "Creator profiles with follower counts, published sample tables, and pack management",
          "Credit system and 4-tier subscription billing both operational ($0–$49.99/month)",
          "24-bit WAV download available on paid tiers",
        ],
        stack: ["PyTorch", "Python", "Next.js", "React", "n8n", "Model Tuning", "AI Audio Generation", "Subscription Billing", "Community Platform"],
      },
      languages: [
        {
          name: "PyTorch",
          iconifyClass: "logos:pytorch-icon",
        },
        {
          name: "Python",
          iconifyClass: "logos:python",
        },
        {
          name: "Next.js",
          iconifyClass: "logos:nextjs-icon",
        },
        {
          name: "React",
          iconifyClass: "logos:react",
        },
        {
          name: "n8n",
          iconifyClass: "simple-icons:n8n",
        },
      ],
    },
    {
      id: "project-6",
      name: "Toronto Neighbourhood Clustering",
      screenshotsFolder: "Toronto Neibourhood Analysis",
      url: "",
      repoUrl: "",
      description:
        "End-to-end data science pipeline clustering 100 Toronto neighbourhoods by venue character using K-means. Scraped postal code data from Wikipedia, pulled venue data from the Foursquare API, engineered top-9 venue category features per neighbourhood, applied unsupervised clustering, and visualised results on two interactive Folium maps — raw distribution and colour-coded cluster output.",
      details: {
        role: "Solo data scientist — full pipeline from raw scrape to interactive geospatial visualisation",
        about:
          "End-to-end data science pipeline that clusters 100 Toronto neighbourhoods by venue character using K-means. Scraped postal code data from Wikipedia, pulled venue data from the Foursquare API, engineered features around the top 9 most common venue categories per neighbourhood, and visualised results on two interactive Folium maps.",
        problem:
          "Toronto's 100+ postal districts have no machine-readable similarity index. Grouping areas by their actual venue character — not just geography — requires combining web scraping, API data, feature engineering, and unsupervised ML in a clean reproducible pipeline.",
        solution:
          "Scraped and cleaned the Wikipedia Toronto postal code table. Merged coordinates from CSV. Pulled venue data per neighbourhood via the Foursquare Places API. One-hot encoded venue categories, ranked the top 9 most common venues per neighbourhood, and applied K-means clustering to produce 5 geographically coherent clusters. Visualised pre- and post-clustering on interactive Folium maps with colour-coded markers.",
        done: [
          "100 neighbourhoods scraped, cleaned, and geocoded",
          "Top-9 venue categories ranked per area",
          "K-means labels joined to master DataFrame with 5 coherent geographic clusters",
          "Two Folium maps produced: raw neighbourhood distribution + cluster-coloured output",
        ],
        stack: ["Python", "pandas", "scikit-learn", "K-means", "Folium", "Foursquare API", "requests", "Jupyter Notebook", "Geospatial Visualisation"],
      },
      languages: [
        {
          name: "Python",
          iconifyClass: "logos:python",
        },
        {
          name: "pandas",
          iconifyClass: "simple-icons:pandas",
        },
        {
          name: "scikit-learn",
          iconifyClass: "simple-icons:scikitlearn",
        },
        {
          name: "Jupyter",
          iconifyClass: "logos:jupyter",
        },
      ],
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "taro_contact.png",
    description:
      "You can contact me at the places mentioned below. I will try to get back to you as fast as I can. ",
  },
};

export {
  logo,
  settings,
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
  projects,
};
